<template>
  <div title="Observações" class="mt-5">
    <b-row>
      <b-col>
        <b-form-group label="Observação" label-for="observacao">
          <v-textarea full-width rows="3" v-model="form.observacao" />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { store } from "../../storeSimplificada";

export default {
  name: "app-simplificada-form-observacao",
  data() {
    return {
      store,
      form: {
        observacao: null,
      },
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  watch: {
    form: {
      handler(value) {
        this.store.formObservacoes = value;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      if (Object.keys(this.$route.params).length !== 0) {
        const { observacao } = this.$route.params.osData;
        this.form.observacao = observacao;
      }
    },
  },
  created() {
    this.getDataInit();
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
  },
};
</script>